var _g, _path, _rect, _rect2, _g2, _path2, _rect3, _rect4, _rect5, _g3, _path3, _rect6, _rect7, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerFilesLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 120,
    viewBox: "0 0 220 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2447_13112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-46 11.8189C-46 8.55523 -43.3542 5.90948 -40.0905 5.90948L-8.32722 5.90948L4.00129 5.90948C5.56701 5.90948 7.06873 6.53085 8.17671 7.63713L27.6115 27.0422C28.7217 28.1507 29.3456 29.6552 29.3456 31.224V56.8342L29.3456 94.9208C29.3456 98.1845 26.6998 100.83 23.4361 100.83H-40.0905C-43.3542 100.83 -46 98.1845 -46 94.9208L-46 11.8189Z",
    fill: "#8EB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.0908 6.27863L4.00098 6.27863C5.46884 6.27863 6.87729 6.8616 7.91602 7.89874L27.3506 27.304C28.3912 28.3432 28.9765 29.7533 28.9766 31.2239L28.9766 94.9212C28.9764 97.9806 26.4959 100.461 23.4365 100.461H-40.0908C-43.1503 100.461 -45.6307 97.9807 -45.6309 94.9212L-45.6309 11.8187C-45.6307 8.75916 -43.1503 6.27877 -40.0908 6.27863Z",
    stroke: "#5F94FF",
    strokeWidth: 0.738682
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 30.0697L4.96875 10.4643C4.96875 9.80651 5.76385 9.47681 6.22936 9.9416L26.6045 30.2857C27.0704 30.7508 26.741 31.5471 26.0826 31.5471H6.44611C5.63019 31.5471 4.96875 30.8856 4.96875 30.0697Z",
    fill: "#155EEF",
    stroke: "#5F94FF",
    strokeWidth: 0.738682
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -38.2439,
    y: 43.0015,
    width: 39.8888,
    height: 2.03273,
    rx: 1.01636,
    fill: "#155EEF",
    stroke: "#5F94FF",
    strokeWidth: 0.738682
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -38.2439,
    y: 56.856,
    width: 46.537,
    height: 2.03273,
    rx: 1.01636,
    fill: "#155EEF",
    stroke: "#5F94FF",
    strokeWidth: 0.738682
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2447_13112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2383 12.898C43.2383 9.63433 45.884 6.98859 49.1477 6.98859L80.9111 6.98859L93.2396 6.98859C94.8053 6.98859 96.307 7.60995 97.415 8.71623L116.85 28.1213C117.96 29.2298 118.584 30.7343 118.584 32.3031V57.9133V95.9999C118.584 99.2636 115.938 101.909 112.674 101.909H49.1477C45.884 101.909 43.2383 99.2636 43.2383 95.9999V12.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1475 7.35773L93.2393 7.35773C94.7071 7.35773 96.1156 7.9407 97.1543 8.97784L116.589 28.3831C117.63 29.4223 118.215 30.8324 118.215 32.303V96.0003C118.215 99.0597 115.734 101.54 112.675 101.54H49.1475C46.088 101.54 43.6076 99.0598 43.6074 96.0003V12.8978C43.6076 9.83826 46.088 7.35788 49.1475 7.35773Z",
    stroke: "#4381E5",
    strokeWidth: 0.738682
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.207 31.1429V11.5376C94.207 10.8798 95.0021 10.5501 95.4676 11.0148L115.843 31.3589C116.309 31.8241 115.979 32.6203 115.321 32.6203H95.6844C94.8685 32.6203 94.207 31.9589 94.207 31.1429Z",
    fill: "#E1E8FB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.625,
    y: 43.7112,
    width: 40.6275,
    height: 2.77141,
    rx: 1.38571,
    fill: "#EAEFFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.625,
    y: 50.6331,
    width: 35.4567,
    height: 2.77141,
    rx: 1.38571,
    fill: "#EAEFFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.625,
    y: 57.5657,
    width: 47.2756,
    height: 2.77141,
    rx: 1.38571,
    fill: "#EAEFFB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2447_13112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.473 11.8189C132.473 8.55523 135.118 5.90948 138.382 5.90948L170.145 5.90948L182.474 5.90948C184.04 5.90948 185.541 6.53085 186.649 7.63713L206.084 27.0422C207.194 28.1507 207.818 29.6552 207.818 31.224V56.8342V94.9208C207.818 98.1845 205.172 100.83 201.909 100.83H138.382C135.118 100.83 132.473 98.1845 132.473 94.9208V11.8189Z",
    fill: "#B8D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.382 6.27863L182.474 6.27863C183.941 6.27863 185.35 6.8616 186.389 7.89874L205.823 27.304C206.864 28.3432 207.449 29.7533 207.449 31.2239V94.9212C207.449 97.9806 204.969 100.461 201.909 100.461H138.382C135.322 100.461 132.842 97.9807 132.842 94.9212V11.8187C132.842 8.75916 135.322 6.27877 138.382 6.27863Z",
    stroke: "#B8D0FF",
    strokeWidth: 0.738682
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.441 30.0697V10.4643C183.441 9.80651 184.237 9.47681 184.702 9.9416L205.077 30.2857C205.543 30.7508 205.214 31.5471 204.555 31.5471H184.919C184.103 31.5471 183.441 30.8856 183.441 30.0697Z",
    fill: "#8EB6FF",
    stroke: "#B8D0FF",
    strokeWidth: 0.738682
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 140.229,
    y: 43.0015,
    width: 39.8888,
    height: 2.03273,
    rx: 1.01636,
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.738682
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 140.229,
    y: 49.9292,
    width: 34.7181,
    height: 2.03273,
    rx: 1.01636,
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.738682
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140.229,
    y: 56.856,
    width: 46.537,
    height: 2.03273,
    rx: 1.01636,
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.738682
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2447_13112",
    x: -57.8189,
    y: 0.0000295639,
    width: 98.9835,
    height: 118.559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.90946
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.90946
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_13112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_13112",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2447_13112",
    x: 31.4194,
    y: 1.07913,
    width: 98.9835,
    height: 118.559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.90946
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.90946
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_13112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_13112",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2447_13112",
    x: 120.654,
    y: 0.0000295639,
    width: 98.9835,
    height: 118.559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.90946
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.90946
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_13112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_13112",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerFilesLeft);
export default __webpack_public_path__ + "static/media/banner-files-left.1bb323cff87c3f523de2205102946cd2.svg";
export { ForwardRef as ReactComponent };